module.exports = __webpack_public_path__ + "img/plus.7c9daead.svg";